export default "<p>bonus works!</p>\n"